module.exports = __webpack_public_path__ + "img/icons8-growing-money-100_1_75.ec01c4f3.png";